export const HOME = '/home';
export const WEDDING = '/portfolio/wedding';
export const ENGAGEMENT = '/portfolio/engagement';
export const FAMILYANDPREGNANCY = '/portfolio/familyandpregnancy';
export const PORTRAIT = '/portfolio/portrait';
export const ABOUT = '/about';
export const CONTACT = '/contact';
export const FORCLIENTS = '/forclients';
